/** @format */

import ChartLinearImg from './images/linear.svg?react';
import ChartLogImg from './images/log.svg?react';
import IconLinearImg from './images/icon_linear.svg?react';
import IconLogImg from './images/icon_log.svg?react';

import {
  IconBox,
  TooltipBox,
  TooltipChartBox,
  TooltipRightColumn,
  TooltipRow,
  TooltipRowHeading,
  TooltipText,
} from './styles';
import {SplitButtons} from '../SplitButtons';
import {ScaleType} from './types';

interface Props {
  color: string;
  currentValue: ScaleType;
  onClick: (newValue: ScaleType) => void;
  disabled: boolean;
}

const WidgetScaleButton = ({color, currentValue, onClick, disabled}: Props) => {
  const handleClickLinear = () => {
    onClick('linear');
  };

  const handleClickLog = () => {
    onClick('log');
  };

  return (
    <SplitButtons<ScaleType>
      options={[
        {
          id: 'linear',
          content: (
            <IconBox>
              <IconLinearImg />
            </IconBox>
          ),
          onClick: handleClickLinear,
        },
        {
          id: 'log',
          content: (
            <IconBox>
              <IconLogImg />
            </IconBox>
          ),
          onClick: handleClickLog,
        },
      ]}
      color={color}
      currentValue={currentValue}
      disabled={disabled}
      PopperContent={
        <TooltipBox>
          <TooltipText>Режимы графика</TooltipText>

          <TooltipRow>
            <TooltipChartBox>
              <ChartLinearImg />
            </TooltipChartBox>

            <TooltipRightColumn>
              <TooltipRowHeading>
                <IconLinearImg />
                <TooltipText>Линейный</TooltipText>
              </TooltipRowHeading>

              <TooltipText>
                Честное соотношение значений, пики сильно меняют вид графика
              </TooltipText>
            </TooltipRightColumn>
          </TooltipRow>

          <TooltipRow>
            <TooltipChartBox>
              <ChartLogImg />
            </TooltipChartBox>

            <TooltipRightColumn>
              <TooltipRowHeading>
                <IconLogImg />
                <TooltipText>Логарифмический</TooltipText>
              </TooltipRowHeading>
              <TooltipText>
                Низкие значения разборчивее. Полезно, когда редкие пики мешают читать график
              </TooltipText>
            </TooltipRightColumn>
          </TooltipRow>
        </TooltipBox>
      }
    />
  );
};

export {WidgetScaleButton};
